import { render, staticRenderFns } from "./NavCrumbs.vue?vue&type=template&id=e12d2100&scoped=true"
import script from "./NavCrumbs.vue?vue&type=script&lang=js"
export * from "./NavCrumbs.vue?vue&type=script&lang=js"
import style0 from "./NavCrumbs.vue?vue&type=style&index=0&id=e12d2100&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12d2100",
  null
  
)

export default component.exports